import './index.css';

import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { persistStore } from 'redux-persist';
import { PersistGate } from 'redux-persist/integration/react';

import App from './App';
import registerServiceWorker from './registerServiceWorker';
import { store } from './store';

const s = store();
const p = persistStore(s);

ReactDOM.render(
  <Provider store={s}>
    <PersistGate loading={null} persistor={p}>
      <App />
    </PersistGate>
  </Provider>
  ,
  document.getElementById('root') as HTMLElement
);
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.tsx